/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale price and how much you save`)
};

const es_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio de venta y cuánto ahorras`)
};

const de_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufspreis und wie viel du sparst`)
};

const nl_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkoopprijs en hoeveel je bespaart`)
};

const fr_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix soldé et montant économisé`)
};

const it_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo scontato e quanto risparmi`)
};

const pt_br2_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço de venda e quanto você economiza`)
};

const pt_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço de venda e quanto poupa`)
};

const ja_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セール価格と節約額`)
};

const zh_pct_nav_discount_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促销价及节省金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_discount_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_discount_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_discount_desc", locale)
	if (locale === "en") return en_pct_nav_discount_desc(inputs)
	if (locale === "es") return es_pct_nav_discount_desc(inputs)
	if (locale === "de") return de_pct_nav_discount_desc(inputs)
	if (locale === "nl") return nl_pct_nav_discount_desc(inputs)
	if (locale === "fr") return fr_pct_nav_discount_desc(inputs)
	if (locale === "it") return it_pct_nav_discount_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_discount_desc(inputs)
	if (locale === "pt") return pt_pct_nav_discount_desc(inputs)
	if (locale === "ja") return ja_pct_nav_discount_desc(inputs)
	return zh_pct_nav_discount_desc(inputs)
};